<template>
  <div class="pos_container_panel" style="padding-left: 2rem; width: 90%">
    <Loading :loading="submitLoading" />
    <!--查询条件-->
    <el-form
      :inline="true"
      :model="searchForm"
      style="margin-left: 6rem; padding-top: 2rem"
    >
      <el-row :gutter="20">
        <el-col :span="5">
          <!-- 目的城市子组件 returnParentValue：给子组件赋值   returnParentValue：子组件返回值（调用方法接收）-->
          <destination
            :returnParentValue="searchForm.city.cityName"
            :isHotCity="false"
          ></destination>
        </el-col>
        <el-col :span="6">
          <!-- 入住、离店时间子组件 setValue：给子组件赋值   returnCheckDate：子组件返回值（调用方法接收）-->
          <date-picker @returnCheckDate="setCheckDate"></date-picker>
        </el-col>
        <el-col :span="6">
          <el-input
            v-model="searchForm.hotelName"
            placeholder="请输入酒店名称"
            autocomplete="off"
          ></el-input>
        </el-col>
      </el-row>
      <!-- <el-row>
        <el-col :span="4">
          <el-form-item label="酒店名称">
            <el-input
              v-model="searchForm.hotelName"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row> -->
      <el-row>
        <el-col :span="24">
          <div style="float: right">
            <el-button type="warning" class="harpIDbtn" @click="searchHotel()"
              >搜索</el-button
            >
          </div>
        </el-col>
      </el-row>
    </el-form>
    <!--table-->
    <el-table
      :data="tableStaticData"
      border
      style="width: 90%; margin-top: 30px; margin-left: 100px"
    >
      <el-table-column
        prop="id"
        label="FX酒店ID"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="name.zh-CN"
        label="酒店名称-中文"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="name.en"
        label="酒店名称-英文"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="contactNumber"
        label="联系电话"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="countryName"
        label="国家"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="provinceName"
        label="省份"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="cityName"
        label="城市"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="address.zh-CN"
        label="中文地址"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="address.en"
        label="英文地址"
        align="center"
      ></el-table-column>
      <el-table-column prop="isActive" label="是否在售" align="center">
        <template #default="{ row }">
          <i v-if="row.isActive" class="el-icon-check"></i>
          <i v-if="!row.isActive" class="el-icon-close"></i>
        </template>
      </el-table-column>
    </el-table>
    <el-table
      :data="tableData"
      border
      style="width: 90%; margin-top: 30px; margin-left: 100px"
    >
      <el-table-column
        prop="id"
        label="FX酒店ID"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="name.zh-CN"
        label="酒店名称-中文"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="name.en"
        label="酒店名称-英文"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="contactNumber"
        label="联系电话"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="countryName"
        label="国家"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="provinceName"
        label="省份"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="cityName"
        label="城市"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="address.zh-CN"
        label="中文地址"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="address.en"
        label="英文地址"
        align="center"
      ></el-table-column>
      <el-table-column prop="isActive" label="是否在售" align="center">
        <template #default="{ row }">
          <i v-if="row.isActive" class="el-icon-check"></i>
          <i v-if="!row.isActive" class="el-icon-close"></i>
        </template>
      </el-table-column>
    </el-table>
    <el-row>
      <div
        style="
          text-align: right;
          padding-right: 5%;
          font-size: 1.3rem;
          margin-top: 10px;
        "
      >
        共有{{ searchForm.staticTotal }}条数据
      </div>
    </el-row>
  </div>
</template>
  
  <script>
import { getHotelLookup } from "@/api/shoppingData";
import Loading from "@/components/Loading.vue";
import DatePicker from "@/components/DatePicker.vue";
import Destination from "@/components/Destination.vue";
import { formatDateTime } from "@/utils/utils.js";
export default {
  name: "HBEShopping",
  components: {
    Loading,
    DatePicker,
    Destination,
  },
  data() {
    return {
      searchForm: {
        hotelName: "",
        staticTotal: 0,
        checkInDate: "",
        checkOutDate: "",
        city: {
          cityCode: "",
          cityName: "",
        },
      },
      tableData:[],
      tableStaticData: [],
      submitLoading: false,
      setDestinationVal: "", //目的城市
    };
  },
  mounted() {},
  computed: {},
  methods: {
    //搜索button
    async searchHotel() {
      if (this.searchForm.hotelName == "") {
        return;
      }
      this.submitLoading = true;
      await this.getStaticHotelList();
      this.submitLoading = false;
    },
    //获取静态酒店列表信息
    async getStaticHotelList() {
      let hotelParam = {
        params: {
          page: 1,
          per_page: 10,
          hotelName: this.searchForm.hotelName,
        },
      };
      let that = this;
      await getHotelLookup(hotelParam)
        .then((res) => {
          if (res.data) {
            that.tableStaticData = res.data.items;
            that.searchForm.staticTotal = res.data.pagination.totalItemCount;
          }
        })
        .catch(function (error) {
          console.log("酒店信息 请求失败", error.objError);
        });
    },
    // 子组件赋值入住 离店时间 datepicker组件
    setCheckDate(value) {
      if (value != null) {
        this.setValue = value;
        // 入住
        this.searchForm.checkInDate = formatDateTime(value[0],"YYYY-MM-DD");
        // 离店
        this.searchForm.checkOutDate = formatDateTime(value[1],"YYYY-MM-DD");
      } else {
        this.setValue = [];
      }
    },
  },
};
</script>
  
  <style scoped>
.paginationsty {
  float: right;
  margin: 1rem 0;
}

.pos_container_panel {
  padding: 0 16rem 4rem;
}

.harpIDbtn {
  width: 10rem;
  height: 3rem;
  padding: 0 !important;
  font-size: 1rem !important;
}
.inputStyle {
  width: 58%;
  margin-left: 85px;
}
.title-divider {
  margin-bottom: 3rem;
  margin-top: -3rem;
  height: 2px;
  background-color: #ff694b;
}
::v-deep .dialog-one .el-dialog__header,
::v-deep .dialog-one .el-tabs__active-bar {
  display: none;
}

::v-deep .dialog-one .el-dialog__body {
  padding: 0px;
}
.search-input {
  margin-left: 10%;
}
.search-btn {
  margin: 2% 5%;
}
.search-btn button {
  padding: 7px 20px;
  border: 1px solid #ff694b;
  color: #ff694b;
}
.select-btn {
  color: #ff694b;
  cursor: pointer;
}
</style>
  